import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';

const styles = theme => ({
  notchedOutline: {
    borderColor: theme.palette.borders.primary
  }
});

class MultiLineTextArea extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    maxLength: PropTypes.string,
    classes: PropTypes.object,
    dataTestId: PropTypes.string
  };

  render() {
    const {
      placeholder,
      defaultValue,
      label,
      onChange,
      value,
      maxLength,
      classes,
      dataTestId
    } = this.props;
    return (
      <Box mt={2.5} mb={2.5}>
        <TextField
          multiline
          rows="3"
          variant="outlined"
          placeholder={placeholder}
          defaultValue={defaultValue}
          label={label}
          onChange={onChange}
          value={value}
          inputProps={{ maxLength, 'data-testid': dataTestId }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline
            }
          }}
        />
      </Box>
    );
  }
}

export default withStyles(styles)(MultiLineTextArea);
